import Model from '../utils/Model'

export class CargoOfRoleType {
  constructor(code, chineseName, englishName) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
  }
}

export const CODE_NAME = 'CargoOfRoleType'

export const OP_TYPE = new CargoOfRoleType(1, '操作', 'op')
export const SALES_TYPE = new CargoOfRoleType(2, '销售', 'sales')
export const CSR_TYPE = new CargoOfRoleType(3, '客服', 'csr')
export const DOC_TYPE = new CargoOfRoleType(4, '单证', 'doc')
export const OVERSEAOP_TYPE = new CargoOfRoleType(5, '海外客服', 'overseaOp')
export const SALES_OF_GOODS = new CargoOfRoleType(6, '揽货销售', 'salesOfGoods')
export const USER_DEFINED_ROLE1 = new CargoOfRoleType(7, '自定义岗位1', 'userDefinedRole1')
export const USER_DEFINED_ROLE2 = new CargoOfRoleType(8, '自定义岗位2', 'userDefinedRole2')
export const PLANNER = new CargoOfRoleType(10, '航线负责人', 'planner')
export const NETWORK_MANAGER = new CargoOfRoleType(11, '网络负责人', 'networkManager')
export const SITE_OP = new CargoOfRoleType(12, '现场操作', 'siteOp')
export const USER_DEFINED_ROLE3 = new CargoOfRoleType(13, '自定义岗位3', 'userDefinedRole3')
export const USER_DEFINED_ROLE4 = new CargoOfRoleType(14, '自定义岗位4', 'userDefinedRole4')
export const USER_DEFINED_ROLE5 = new CargoOfRoleType(15, '自定义岗位5', 'userDefinedRole5')
export const USER_DEFINED_ROLE6 = new CargoOfRoleType(16, '自定义岗位6', 'userDefinedRole6')
export const USER_DEFINED_ROLE7 = new CargoOfRoleType(17, '自定义岗位7', 'userDefinedRole7')
export const USER_DEFINED_ROLE8 = new CargoOfRoleType(18, '自定义岗位8', 'userDefinedRole8')

export const COMPANY_USER_ROLE_TYPES = [SALES_TYPE, CSR_TYPE, DOC_TYPE, SALES_OF_GOODS, USER_DEFINED_ROLE1, USER_DEFINED_ROLE2, USER_DEFINED_ROLE3, USER_DEFINED_ROLE4, USER_DEFINED_ROLE5, USER_DEFINED_ROLE6, USER_DEFINED_ROLE7]

export const COMPANY_USER_ROLE_TYPES_HC = [OP_TYPE, SALES_TYPE, CSR_TYPE, DOC_TYPE, OVERSEAOP_TYPE, SALES_OF_GOODS, USER_DEFINED_ROLE1, USER_DEFINED_ROLE2, USER_DEFINED_ROLE3, USER_DEFINED_ROLE4, USER_DEFINED_ROLE5, USER_DEFINED_ROLE6, USER_DEFINED_ROLE7]

export const COMPANY_USER_LIST_ROLE_TYPES = [SALES_TYPE, CSR_TYPE, DOC_TYPE, OVERSEAOP_TYPE, SALES_OF_GOODS, USER_DEFINED_ROLE1, USER_DEFINED_ROLE2, USER_DEFINED_ROLE3, USER_DEFINED_ROLE4, USER_DEFINED_ROLE5, USER_DEFINED_ROLE6, USER_DEFINED_ROLE7]

export const ROLE_TYPES = [SALES_TYPE, CSR_TYPE, DOC_TYPE, OVERSEAOP_TYPE, SALES_OF_GOODS, USER_DEFINED_ROLE1, USER_DEFINED_ROLE2,
  USER_DEFINED_ROLE3, USER_DEFINED_ROLE4, USER_DEFINED_ROLE5, USER_DEFINED_ROLE6, USER_DEFINED_ROLE7, NETWORK_MANAGER]

export const ROLE_TYPES_HC = [OP_TYPE, ...ROLE_TYPES]

export const ROLE_TYPES_ALL = [OP_TYPE, ...ROLE_TYPES]

export const ALL_ROLE_TYPES = [OP_TYPE, SALES_TYPE, CSR_TYPE, DOC_TYPE, OVERSEAOP_TYPE, SALES_OF_GOODS, USER_DEFINED_ROLE1, USER_DEFINED_ROLE2]

/**
 * 航交所告警角色列表
 */
export const COMPANY_USER_LIST_ROLE_AVIATION_EXCHANGE_WARNING = [OP_TYPE, CSR_TYPE, SALES_TYPE, SALES_OF_GOODS, PLANNER, SITE_OP, OVERSEAOP_TYPE, DOC_TYPE, USER_DEFINED_ROLE1, USER_DEFINED_ROLE2,
  USER_DEFINED_ROLE3, USER_DEFINED_ROLE4, USER_DEFINED_ROLE5, USER_DEFINED_ROLE6, USER_DEFINED_ROLE7]

/**
 * 预警角色
 * @type {CargoOfRoleType[]}
 */
export const WARNING_ROLE_TYPES = [OP_TYPE, SALES_TYPE, CSR_TYPE, DOC_TYPE, OVERSEAOP_TYPE, PLANNER, SALES_OF_GOODS, SITE_OP, USER_DEFINED_ROLE1, USER_DEFINED_ROLE2,
  USER_DEFINED_ROLE3, USER_DEFINED_ROLE4, USER_DEFINED_ROLE5, USER_DEFINED_ROLE6, USER_DEFINED_ROLE7, USER_DEFINED_ROLE8]
/**
 *  return null:没找到.
 */
export function getCargoOfRoleTypeByCode(code) {
  return Model.getObjByCode(code, ROLE_TYPES_ALL)
}
